import styled from "styled-components";
import { vwDesktop, vwMobile } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import { Tabs } from "../Tabs";

export const Container = styled.div<{ backgroundColor?: string }>`
  padding: ${vwMobile(40)} ${vwMobile(20)};
  background-color: ${(p) =>
    p.backgroundColor ?? "var(--color-green-90)"};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${vwDesktop(20)} ${vwDesktop(150)} ${vwDesktop(20)};
  }
`;

export const StyledTabs = styled(Tabs)`
  padding: 0 0 ${vwMobile(80)};

  && {
    background-color: transparent;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: 0 0 ${vwDesktop(120)};
  }

  .tab-container {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: ${vwMobile(20)};
    background: transparent;
    padding: 0 0 ${vwMobile(40)};
    width: 100%;

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      padding: 0 0 ${vwDesktop(64)};
    }
  }
`;

export const AccordionContainer = styled.section``;

export const BlogHeroWrapper = styled.div`
  background-color: var(--color-green-90);
  & > div {
    margin-bottom: ${vwMobile(0)};
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: 0 0 ${vwDesktop(100)} ${vwDesktop(100)};
  }
`;
